import React from "react";
import styled from "styled-components";
import { Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import handleCopy from "src/scenes/developer-portal/handle-copy";
import { ToastContext } from "src/components/providers/toast-provider";
import { useAuth } from "../../components/providers/auth-context";

const CardContainer = styled(Paper)`
    border-radius: 14px;
    padding: 32px;
    border: 2px solid transparent;
`;

const UserIdCard = () => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const { user } = useAuth();

    return (
        <CardContainer>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item>
                    <Stack direction="column" spacing={2}>
                        <Typography>User ID</Typography>

                        <Stack
                            direction="row"
                            alignItems="center"
                            style={{ width: "100%" }}
                            spacing={1}
                        >
                            <Typography style={{ fontSize: "12px", opacity: "0.7" }}>
                                {user.user_id}
                            </Typography>
                            <IconButton
                                size="small"
                                aria-label="copy user id"
                                onClick={() =>
                                    handleCopy({
                                        value: user.user_id,
                                        setMessage,
                                        setSeverity,
                                        setIsToastTriggered,
                                    })
                                }
                            >
                                <ContentCopyIcon size="small" />
                            </IconButton>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </CardContainer>
    );
};

export default UserIdCard;
